import { createSlice } from '@reduxjs/toolkit';

// Load initial state from localStorage if available
const loadAuthState = () => {
    try {
        if (typeof window !== 'undefined') {
            const authData = localStorage.getItem('auth_data');
            if (authData) {
                return JSON.parse(authData);
            }
        }
    } catch (error) {
        console.error('Error loading auth state from localStorage:', error);
    }
    return {
        user: null,
        token: null,
        role: null,
        isAuthenticated: false,
        loading: false,
        error: null
    };
};

const initialState = loadAuthState();

const authSlice = createSlice({
    name: 'auth',
    initialState: initialState,
    reducers: {
        setCredentials: (state, action) => {
            const { user, token, role } = action.payload;
            state.user = user;
            state.token = token;
            state.role = role;
            state.isAuthenticated = true;
            state.error = null;

            // Save to localStorage
            localStorage.setItem('auth_data', JSON.stringify({
                user: user,
                token: token,
                role: role,
                isAuthenticated: true,
                loading: false,
                error: null
            }));
        },
        setUser: (state, action) => {
            state.user = action.payload;

            let auth_data = JSON.parse(localStorage.getItem('auth_data'));
            auth_data.user = action.payload;
            localStorage.setItem('auth_data', JSON.stringify(auth_data));
        },
        setUserProfile: (state, action) => {
            state.user.profile = action.payload;

            let auth_data = JSON.parse(localStorage.getItem('auth_data'));
            auth_data.user.profile = action.payload;
            localStorage.setItem('auth_data', JSON.stringify(auth_data));
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        logout: (state) => {
            state.user = null;
            state.token = null;
            state.role = null;
            state.isAuthenticated = false;
            state.error = null;

            // Clear from localStorage
            localStorage.removeItem('auth_data');
            localStorage.removeItem('token');
        }
    }
});

export const { setCredentials, setUser, setUserProfile, setLoading, setError, logout } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentUserProfile = (state) => state.auth.user?.profile;
export const selectCurrentUserRole = (state) => state.auth.role;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthError = (state) => state.auth.error;
export const selectAuthLoading = (state) => state.auth.loading;